import "./NoLocationScreen.css";
import { StoreLocator } from "../components/StoreLocator/StoreLocator";
import { useSelector } from "react-redux";
import LoadingScreen from "./LoadingScreen";
import { useIsAuthenticated } from "@azure/msal-react";

export default function NoLocationScreen() {
  const carePlusReferrer = useSelector(
    (state) => state.scheduler.carePlusReferrer
  );
  const isAuthenticated = useIsAuthenticated();
  const dgbReferrer = useSelector((state) => state.scheduler.dgbReferrer);

  return dgbReferrer && !isAuthenticated ? (
    <LoadingScreen />
  ) : (
    <div className="no-location">
      {carePlusReferrer === "careplus" ? (
        <>
          <h1 className="heading">
            {process.env.REACT_APP_CAREPLUS_FULL_RELEASE === "true" ? (
              <p className="care-plus-heading">
                <br />
                Please select a shop here for a qualifying{" "}
                <span className="care-plus-brand">Care</span>
                <span className="care-plus-brand-plus">+</span> inspection
                today.
                <br />
              </p>
            ) : (
              <p className="care-plus-heading">
                <span className="care-plus-brand">Care</span>
                <span className="care-plus-brand-plus">+</span> is still new,
                and not yet offered everywhere.
                <sup>*</sup>
                <br />
                Please select a shop here for a qualifying inspection today.
                <br />
                <p className="info-text">
                  <sup>*</sup>Service plans and claims are honored universally
                  while we rollout qualifying inspections and sales training to
                  all shops.
                </p>
              </p>
            )}
          </h1>
        </>
      ) : (
        <h1 className="heading">
          Before you get started, you need to find a local shop.
        </h1>
      )}
      <div className={"store-locator"}>
        <StoreLocator />
      </div>
    </div>
  );
}
